import React from 'react'

const Settings = () => {
    return (
        <div>
            Coming soon...
        </div>
    )
}

export default Settings